import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShippingAddress } from "../../types";

type Props = {
  value: Partial<ShippingAddress>;
  onChange: (v: Partial<ShippingAddress>) => void;
};

export function ShippingForm({ value, onChange }: Props) {
  const set =
    (k: keyof ShippingAddress) => (e: React.ChangeEvent<HTMLInputElement>) =>
      onChange({ ...value, [k]: e.target.value });

  return (
    <section
      className="rounded-lg border border-gray-200 dark:border-slate-700 p-4 space-y-3"
      data-testid="shipping-form"
    >
      <h3 className="text-base font-medium text-gray-900 dark:text-white">
        Shipping address
      </h3>

      <div className="space-y-1.5">
        <Label htmlFor="shipping-address-line-1">Address line 1</Label>
        <Input
          id="shipping-address-line-1"
          onChange={set("addressLine1")}
          value={value.addressLine1 ?? ""}
        />
      </div>

      <div className="space-y-1.5">
        <Label htmlFor="shipping-address-line-2">
          Address line 2 (optional)
        </Label>
        <Input
          id="shipping-address-line-2"
          onChange={set("addressLine2")}
          value={value.addressLine2 ?? ""}
        />
      </div>

      <div className="grid grid-cols-3 gap-3">
        <div className="space-y-1.5">
          <Label htmlFor="shipping-city">City</Label>
          <Input
            id="shipping-city"
            onChange={set("city")}
            value={value.city ?? ""}
          />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="shipping-state">State</Label>
          <Input
            id="shipping-state"
            onChange={set("state")}
            value={value.state ?? ""}
          />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="shipping-zip">Zip</Label>
          <Input
            id="shipping-zip"
            onChange={set("zipCode")}
            value={value.zipCode ?? ""}
          />
        </div>
      </div>
    </section>
  );
}

export function isShippingComplete(value: Partial<ShippingAddress>): boolean {
  return Boolean(
    value.addressLine1 && value.city && value.state && value.zipCode,
  );
}
